import $ from 'jquery';
import scrollTo from './scrollTo';

$(function () {

    var els = $('[data-scroll-button]');
    var footer = $('.footer');
    if (!els.length) return;
    var ul = $("<ul>").addClass('scroll-buttons').appendTo($('body'));

    els.each(function () {
        var $el = $(this);
        var text = $el.data('scroll-button');
        var li = $("<li>").appendTo(ul);
        li.html(window.App.icons.arrow_down_fat + "<i></i><span>" + text + "</span>");
        li.on('click', function () {
            window.hideHeader = true;
            scrollTo($el);
            setTimeout(function () {
                window.hideHeader = false;
            }, 500);

        });
    });

    function updateScrollButtons() {

        els.each(function (n) {
            var pos = this.getBoundingClientRect().top;
            ul.find('li').eq(n).toggleClass('up', pos <= 0);
        });

        var footerPos = footer.get(0).getBoundingClientRect();
        ul.toggleClass('hide', footerPos.top < window.innerHeight);
    }

    $(window).on('scroll', updateScrollButtons);


});